













import Vue from "vue";

// Components
import FiltersCard from "@/views/App/CashFlow/UsersBalance/FiltersCard.vue";
import ReportTableCard from "@/views/App/CashFlow/BagsCashReport/ReportTableCard.vue";
import DetailsTableCard from "@/views/App/CashFlow/BagsCashReport/DetailsTableCard.vue";

// Model
import menu from "@/store/modules/ApplicationModule/data/menu";
import { GetBagsCashReportAvailableCurrenciesCommand } from "@/model/communication/bagsCashReport/GetBagsCashReportAvailableCurrenciesCommand";
import { GetBagsCashReportCommand } from "@/model/communication/bagsCashReport/GetBagsCashReportCommand";
import { GetBagsCashReportReqData } from "@/model/communication/bagsCashReport/GetBagsCashReportReqData";
import { GetBagsCashReportResData } from "@/model/communication/bagsCashReport/GetBagsCashReportResData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { BagsCashReportEntry } from "@/model/data/bagsCashReport/BagsCashReportEntry";
import { ExportBagsCashReportCommand } from "@/model/communication/bagsCashReport/ExportBagsCashReportCommand";
import { ExportBagsCashReportDetailsCommand } from "@/model/communication/bagsCashReport/ExportBagsCashReportDetailsCommand";

export default Vue.extend({
    components: {
        FiltersCard,
        ReportTableCard,
        DetailsTableCard,
    },
    data() {
        return {
            loading: false,
            filters: null,
            availableCurrencies: [],
            bagsCashReportEntries: [],
            bagsCashReportTotals: [],
            showDetailsDialog: false,
            showDetailsDialogEntry: null,
        };
    },
    computed: {
        menuEntry() {
            return menu.find((m) => m.name == "Cash Flow").children.find((c) => c.name == "Bags Cash Report");
        },
    },
    watch: {
        showDetailsDialog(newValue) {
            // se ho chiuso il dialog
            if (!newValue) this.showDetailsDialogEntry = null;
        },
    },
    methods: {
        async GetBagsCashReport() {
            try {
                if (!this.loading) {
                    this.loading = true;

                    let res: GetBagsCashReportResData = await new GetBagsCashReportCommand((this.filters as GetBagsCashReportReqData).GetReqDataPayload()).execute();

                    if (res.responseStatus == ApiResponseStatusEnum.Success) {
                        this.bagsCashReportEntries = res.bagsCashReportEntries;
                        this.bagsCashReportTotals = res.bagsCashReportTotals;
                    }
                    this.loading = false;
                }
            } catch (error) {
                console.error("GetBagsCashReport(): ", error);
                this.loading = false;
            }
        },
        async GetBagsCashReportAvailableCurrencies() {
            try {
                this.availableCurrencies = await new GetBagsCashReportAvailableCurrenciesCommand().execute();
            } catch (error) {
                console.error("GetBagsCashReportAvailableCurrencies(): ", error);
                this.availableCurrencies = [];
            }
        },
        async onDownload(exportType) {
            console.log("Download required, exportType: ", exportType);
            try {
                if (!this.loading) {
                    this.loading = true;
                    const res = await new ExportBagsCashReportCommand((this.filters as GetBagsCashReportReqData).GetReqDataPayload(), exportType).execute();
                    let fileURL = window.URL.createObjectURL(new Blob([res.data]));
                    let fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.loading = false;
                }
            } catch (e) {
                console.log("Something went wrong during ExportBagsCashReportCommand execution: ", e);
                this.loading = false;
            }
        },
        async onDownloadDetails(exportType) {
            console.log("Download details required, exportType: ", exportType);
            try {
                if (!this.loading) {
                    this.loading = true;
                    const res = await new ExportBagsCashReportDetailsCommand(
                        this.filters as GetBagsCashReportReqData,
                        exportType,
                        this.showDetailsDialogEntry as BagsCashReportEntry
                    ).execute();
                    let fileURL = window.URL.createObjectURL(new Blob([res.data]));
                    let fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.loading = false;
                }
            } catch (e) {
                console.log("Something went wrong during ExportBagsCashReportDetailsCommand execution: ", e);
                this.loading = false;
            }
        },

        showDetails(item: BagsCashReportEntry) {
            this.showDetailsDialogEntry = item;
            this.showDetailsDialog = true;
        },
    },
    mounted() {
        this.filters = new GetBagsCashReportReqData();
        this.GetBagsCashReportAvailableCurrencies();
    },
});
